import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AttachmentHttpService } from './attachment.http.service';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { Attachment } from '../../models/attachment';
import { List } from 'immutable';

@Injectable()
export class AttachmentStore {

  private currentAttachments: BehaviorSubject<List<Attachment>> = new BehaviorSubject(List([]));

  constructor(private attachmentHttpService: AttachmentHttpService,
              private flashMessagesService: FlashMessagesService) {
  }

  get attachments(): Observable<any> {
    return this.currentAttachments.asObservable();
  }

  loadAttachments(eventId: number): void {
    this.getAttachments(eventId).subscribe();
  }

  getAttachments(eventId: number): Observable<List<Attachment>> {
    return this.attachmentHttpService.getForEvent(eventId)
      .catch((error: any) => {
        // Catch error here so resolver also displays error.
        this.flashMessagesService.error('MESSAGES.ERROR.GET_ATTACHMENTS', `Error retrieving attachments; ${error}`);
        return Observable.throw(error);
      })
      .map((res: List<Attachment>) => {
        this.currentAttachments.next(List(res));
        return res;
      });
  }

  addAttachment(eventId: number, file: File): Observable<any> {
    return this.attachmentHttpService.add(eventId, file)
      .map((res) => {
        this.loadAttachments(eventId);
        return res;
      });
  }

  deleteAttachment(eventId: number, uniqueId: string): Observable<any> {
    return this.attachmentHttpService.delete(uniqueId)
      .map((res) => {
        this.loadAttachments(eventId);
        return res;
      });
  }

  get(uniqueId: string): Observable<string> {
    return this.attachmentHttpService.get(uniqueId)
      .map((res: string) => {
        window.open(res);
        return res;
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/attachment/attachment.store.ts